<template>
  <b-form>
    <b-form-group>
      <vue-upload-multiple-image :data-images="[]" @click="test()" :maxImage="7" @upload-success="fileSelected(...arguments)" @before-remove="confirmRemove(...arguments)" dragText="Перетащите файлы сюда" dropText="" browseText="Выбрать" class="drop-zone" :showPrimary="false" popupText="" primaryText="" markIsPrimaryText=""></vue-upload-multiple-image>
    </b-form-group>
    <b-alert :show="!!error" variant="danger">{{ error }}</b-alert>
  </b-form>
</template>

<script>
import VueUploadMultipleImage from 'vue-upload-multiple-image'

export default {
  name: 'PhotoForm',
  components: {
    VueUploadMultipleImage
  },
  model: {
    prop: 'photo',
    event: 'sync'
  },
  props: {
    photo: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    model: [],
    error: '',
    preview: []
  }),
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.model = this.photo
    },
    sync () {
      this.$emit('sync', this.model)
    },

    fileSelected (formData, index, fileList) {
      // this.model[index] = formData
      this.$set(this.model, index, formData)
      this.sync()
    },
    confirmRemove (index, done, fileList) {
      this.model.splice(index, 1)
      done()
    },

    test () {
      console.log()
    }
  }
}
</script>

<style lang="scss">
.drop-zone {
  .image-container {
    width: 100% !important;
    height: 320px !important;
  }
  .image-list-container {
    max-width: 100% !important;

    .image-list-item {
      width: 105px;
      height: 86px;

      img {
        max-width: 96px !important;
        max-height: 77px !important;
      }
    }
  }

  .preview-image {
    height: 280px !important;
  }

  img {
    &.show-img {
      max-width: 100%;
      max-height: 280px;
      // margin-top: 10px;
    }
  }
}
</style>
